import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'enx-shared-ui-image-shell',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule],
  templateUrl: './shared-ui-image-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        @apply grow;
        @apply flex;
        @apply flex-col;
      }
    `,
  ],
})
export class SharedUiImageShellComponent {
  imageSrc = input.required<string>();
  imageAlt = input.required<string>();
  isImageFullSize = input<boolean>(false);
  useShadow = input<boolean>(true);
}
